module.exports = __webpack_public_path__ + "img/face-anxious-sweat.299443eb.svg";